<template>
  <v-container fluid>
    <v-alert v-if="1===2"
             type="success"
             dense
             dismissible
             :icon="false"
             tile>
      <strong>Update:</strong> We've changed how you send emails so it's done in 3 easy steps. <a href="#giveFeedback" @click.prevent="giveFeedback" target="_blank" class="font-weight-bold white--text">Give us feedback</a>.
    </v-alert>
    <email-wizard-stepper>
    </email-wizard-stepper>

    <router-view>
    </router-view>
  </v-container>
</template>
<script>
import {mapGetters} from 'vuex';
import helpScoutService from '../../../../../ml/services/helpScoutService';
import EmailWizardStepper from './components/Stepper';

export default {
  components: {EmailWizardStepper},
  computed: {
    ...mapGetters([
      'canSendEmail', // MLD-3917
      'isAdmin', // MLD-3766
      'isEmailComposerEnabled', // MLD-6403
      'isMember', // MLD-3766
      'team',
      'user',
    ]),
  },
  created() {
    if (this.isEmailComposerEnabled) { // MLD-6403
      this.$router.replace({name: `${this.$root.routePrefix}.send.email`, query: this.$route.query});
      return;
    }
    if (this.canSendEmail === false) { // MLD-3766
      this.$toast.error('You are not allowed to send emails that way.');
      this.$router.replace({name: `${this.$root.routePrefix}.home`});
      return;
    }
    this.$store.dispatch('emailCart/reset');
    if (this.$route.name.includes('.template')) {
      this.$store.dispatch('emailCart/setStep', 1);
    } else if (this.$route.name.includes('.recipient')) {
      this.$store.dispatch('emailCart/setStep', 2);
    } else if (this.$route.name.includes('.compose')) {
      this.$store.dispatch('emailCart/setStep', 3);
    }
  },
  methods: {
    giveFeedback() {
      if (this.team.is_support_standard && helpScoutService.isAvailable()) {
        helpScoutService.init();
        helpScoutService.prefill(this.user, {
          name: this.user.name,
          email: this.user.email,
          subject: 'Feedback about the email functionality'
        })
      } else {
        console.log('Opening email program');
        const link = document.createElement('a');
        link.href = 'mailto:support@mobilelocker.com?subject=Feedback about the email functionality';
        link.target = '_blank';
        link.dispatchEvent(new MouseEvent(`click`, {bubbles: true, cancelable: true, view: window}));
        //document.removeChild(link);
      }
    }
  }
}
</script>
